import React, { Component } from 'react';

const withProps = (propsCreator) => {
  return (Decorated) => {
    return class WithProps extends Component {
      static displayName = `withProps(${Decorated.displayName})`;

      render() {
        return (
          <Decorated {...propsCreator(this.props)} />
        );
      }
    };
  };
};

export default withProps;



// WEBPACK FOOTER //
// ./plugins/app/site/pagesections/officetabs/js/withProps.js